import type { SiteContentLayoutProps } from '../constants/content-pages'
import '../styles/content-page.scss'

export function SiteContentLayout({
  eyebrow,
  title,
  lead,
  children,
}: SiteContentLayoutProps) {
  return (
    <div className="content-page">
      <section className="content-page__hero">
        <div className="container">
          {eyebrow ? <p className="content-page__eyebrow">{eyebrow}</p> : null}
          <h1>{title}</h1>
          {lead ? <p className="content-page__lead">{lead}</p> : null}
        </div>
      </section>
      <section className="section content-page__body">
        <div className="container">{children}</div>
      </section>
    </div>
  )
}
